import { ICard, PlanCardAddons, IShopCard } from "../../components/shop/types";
import { TranslationKey } from "../../i18n";

type T = (key: TranslationKey, vars?: Record<string, string | number>) => string;

/**
 * The arrays below stay the single source of prices and keys; the English
 * strings double as lookup keys for the dictionaries. `localize*` helpers
 * return copies with the visitor's language applied, falling back to the
 * English text for anything without a translation.
 */
const planTextKeys: Record<string, TranslationKey> = {
  "INCLUDE 1 PC OF": "plans.basic.title",
  "TOUCH TALK visit card or sticker": "plans.basic.description",
  "PET NECK TAG": "plans.pro.title",
  "and page function": "plans.pro.description",
  "Social networks": "plans.option.socialNetworks",
  Messengers: "plans.option.messengers",
  URL: "plans.option.url",
  "Saving contacts": "plans.option.savingContacts",
  "Branded Card": "plans.option.brandedCard",
  "Custom design your page buttons": "plans.option.customButtons",
  "Ability to change background": "plans.option.background",
  "Map function": "plans.option.map",
  "Rewiew function": "plans.option.review",
  "Swipe photos with user page": "plans.option.swipe",
  "Free replacement standard pvc card": "plans.option.replacement",
  "Pet page making": "plans.option.petPage",
  "Metal card": "shop.addon.metalCard",
  "Metal Card": "shop.metalCard",
  "Wooden Card": "shop.woodenCard",
  "1 Month": "plans.period.1",
  "3 Month": "plans.period.3",
  "6 Month": "plans.period.6",
  "12 Month": "plans.period.12",
};

export const planText = (t: T, text: string): string => {
  const key = planTextKeys[text];
  return key ? t(key) : text;
};

export const localizePlanCard = (t: T, card: ICard): ICard => ({
  ...card,
  title: planText(t, card.title),
  description: card.description ? planText(t, card.description) : card.description,
  options: card.options.map((o) => planText(t, o)),
});

export const localizeShopCard = (t: T, card: IShopCard): IShopCard => ({
  ...card,
  title: planText(t, card.title),
});

export const planCards: ICard[] = [
  {
    key: "BASIC",
    title: "BASIC",
    price: 3000,
    popular: false,
    currency: "֏",
    pcs: "1",
    options: ["Social networks", "Messengers", "URL", "Saving contacts"],
  },
  {
    key: "PRO",
    title: "PRO",
    price: 4500,
    currency: "֏",
    popular: true,
    pcs: "1",
    options: [
      "All BASIC features",
      "Branded sticker",
      "Custom colors your page buttons",
      "Ability to change background",
    ],
  },
  {
    key: "PREMIUM",
    title: "PREMIUM",
    price: 50000,
    currency: "֏",
    popular: false,
    pcs: "10",
    options: [
      "All PRO features",
      "WIFI function",
      "MENU function",
      "Map function",
      "Rewiew function",
      "Banner with user page",
      "Connect your own domain",
    ],
  },
  {
    key: "BUSINESS",
    title: "BUSINESS",
    price: 75000,
    currency: "֏",
    popular: false,
    pcs: "10",
    options: [
      "All PREMIUM features",
      "Design service",
      "Touch Talk homepage banner",
      "Create up to 20  sub profiles",
    ],
  },
];

export const newPlanCards: ICard[] = [
  {
    key: "BASIC",
    title: "INCLUDE 1 PC OF",
    description: "TOUCH TALK visit card or sticker",
    price: 3000,
    popular: false,
    imgUrl: "card_touch",
    currency: "֏",
    pcs: "1",
    options: [
      "Social networks",
      "Messengers",
      "URL",
      "Saving contacts",
      "Branded Card",
      "Custom design your page buttons",
      "Ability to change background",
      "Map function",
      "Rewiew function",
      "Swipe photos with user page",
      "Free replacement standard pvc card",
      "Pet page making",
    ],
  },
  {
    key: "PRO",
    title: "PET NECK TAG",
    description: "and page function",
    price: 4500,
    imgUrl: "card_pet",
    currency: "֏",
    popular: true,
    pcs: "1",
    options: [
      "Social networks",
      "Messengers",
      "URL",
      "Saving contacts",
      "Branded Card",
      "Custom design your page buttons",
      "Ability to change background",
      "Map function",
      "Rewiew function",
      "Swipe photos with user page",
      "Free replacement standard pvc card",
      "Pet page making",
    ],
  },
];

export const planCardAddons: PlanCardAddons[] = [
  {
    key: "Bronze",
    title: "Metal card",
    price: 3000,
    currency: "֏",
  },
  {
    key: "Silver",
    title: "Metal card",
    price: 6000,
    currency: "֏",
  },
  {
    key: "Gold",
    title: "Metal card",
    price: 9000,
    currency: "֏",
  },
];

export const planTabs = [
  {
    key: "1 Month",
    discount: 0,
  },
  {
    key: "3 Month",
    discount: 10,
  },
  {
    key: "6 Month",
    discount: 15,
  },
  {
    key: "12 Month",
    discount: 20,
  },
];

export const nfcCards: IShopCard[] = [
  {
    key: "Metal",
    title: "Metal Card",
    description: "Lorem Ipsum",
    popular: true,
    imgUrl: "card_touch",
  },
  {
    key: "Wooden",
    title: "Wooden Card",
    description: "Lorem Ipsum",
    popular: false,
    imgUrl: "card_touch",
  },
];

export const nfcStickers: IShopCard[] = [
  {
    key: "Metal1",
    title: "Metal Card",
    description: "Lorem Ipsum",
    popular: false,
    imgUrl: "card_touch",
  },
  {
    key: "Wooden1",
    title: "Wooden Card",
    description: "Lorem Ipsum",
    popular: false,
    imgUrl: "card_touch",
  },
];

export const petTagCards: IShopCard[] = [
  {
    key: "Metal2",
    title: "Metal Card",
    description: "Lorem Ipsum",
    popular: false,
    imgUrl: "card_touch",
  },
];
